var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('edit-base',{attrs:{"data":_vm.data}})],1)],1),_c('b-row',[_c('b-col',[_c('edit-subtype',{attrs:{"data":_vm.data}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }